<template>
  <div class="documenti-richiesti">
    <div class="row row-custom">
      <div class="titolo-app col-xl-11 col-lg-8 col-1 no-padding">
        <span class="titolo-bold d-none d-sm-block">
          {{ $t('documentirichiesti.documentirichiesti').toUpperCase() }}
        </span>
      </div>

      <div class="icone col-xl-13 col-lg-16 col-23 no-padding" v-show="showIcone">
        <div class="icona" @click="goToOrdini">
          <div class="icona-menu">
            <icon name="riv-lista" scale="1.5"></icon>
          </div>
          <div class="label-menu no-padding">
            <span v-html="$t('documentirichiesti.listaOrdini')"></span>
          </div>
        </div>
      </div>

    </div>
    <div id="contenitore" class="contenitore col-24 no-padding"
         :style="{ height: contenitoreHeight + 'px', overflowY: (showScroll) ? 'auto' : 'hidden' }">
      <keep-alive>
        <router-view @hideScroll="hideScroll" @showScroll="showScroll = true" :contenitoreHeight="contenitoreHeight" :prefixApp="prefixApp"></router-view>
      </keep-alive>
    </div>
  </div>
</template>



<script>
  import {bus} from '@/components/Bus.js'

  export default {
    name: 'DocumentiRichiesti',
    props: {
      contenitoreHeight: {
        type: Number,
        required: true,
        default: 550
      }
    },
    i18n: {
      messages: {
        it_IT: {
          documentirichiesti: {
            documentirichiesti: 'Documenti Richiesti',
            listaOrdini: 'Lista<br>Ordini'
          }
        },
        fr_FR: {
          documentirichiesti: {
            documentirichiesti: 'Documents demandés',
            listaOrdini: 'Liste<br>Commandes'
          }
        },
        es_ES: {
          documentirichiesti: {
            documentirichiesti: 'Documentos requeridos',
            listaOrdini: 'Lista<br>Pedidos'
          }
        },
        de_DE: {
          documentirichiesti: {
            documentirichiesti: 'Angeforderte Dokumente',
            listaOrdini: 'Auftragsliste'
          }
        },
        en_GB: {
          documentirichiesti: {
            documentirichiesti: 'Requested documents',
            listaOrdini: 'List<br>Orders'
          }
        }
      }
    },
    data () {
      return {
        showScroll: true,
        prefixApp: 'dc',
        // Parametro della rotta per capire da che app sto arrivando
        areaAcq: false
      }
    },
    activated: function () {
      this.$set(this, 'areaAcq', this.$route.params.areaAcq === undefined ? false : this.$route.params.areaAcq)
    },
    methods: {
      hideScroll: function () {
        var container = this.$el.querySelector('#contenitore')
        container.scrollTop = 0
        this.showScroll = false
      },
      indietro: function () {
        this.$router.push({name: ''})
      },
      goToOrdini: function () {
        if (this.areaAcq) {
          bus.$emit('changeActiveApp', 'SituazioneOrdini', 'UFFACQ')
          this.$router.push({name: 'SOOrdini'})
        } else {
          bus.$emit('changeActiveApp', 'WebAssociaDip', 'ACCSTA')
          this.$router.push({name: 'ASSOrdini'})
        }
      },
    },
    computed: {
      showIcone: function () {
        let path = this.$route.path
        return (path.indexOf('/elenco') >= 0)
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../../assets/less/general.less";

  .documenti-richiesti {
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px, @color: @greenRiva);
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 55px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .icone {
      padding-top: 10px;
      padding-bottom: 10px;
      .icona:hover {
        cursor: pointer;
      }
      .icona {
        text-align: right;
        padding-right: 50px;
      }
      .icona-menu {
        padding-left: 0px;
        padding-right: 3px;
        // padding-top: 3px;
        text-align: right;
        display: inline-block;
        vertical-align: middle;
      }
      .label-menu {
        .set-font(@size: 13px, @family: 'os-semibold');
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        line-height: 17px;
        // margin-top: -4px;
      }
    }
    .contenitore {
      -webkit-box-shadow: 0 0 10px 2px #cecece;
      -moz-box-shadow: 0 0 10px 2px #cecece;
      box-shadow: 0 0 10px 2px #cecece;
      background-color: #ffffff;
      margin: auto;
      overflow-x: hidden;
      border-radius: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AccessoStabilimenti/GestioneAppalti/DocumentiRichiesti/DocumentiRichiesti.vue